import { z } from 'zod';

// Password policy and link lifetimes shared by the API and the auth pages.
export const PASSWORD_MIN_LENGTH = 12;
export const RESET_LINK_TTL_MINUTES = 60;

// Explicit agreement to /privacy at collection (PDPA). Required on candidate
// profile creation and company sign-up; the server stores when it was given.
export const acceptPrivacySchema = z.literal(true, 'Agree to the privacy policy to continue');
